export const CAR_MARKET_PRICE_REQUEST = 'CAR_MARKET_PRICE_REQUEST'
export const CAR_MARKET_PRICE_SUCCESS = 'CAR_MARKET_PRICE_SUCCESS'
export const CAR_MARKET_PRICE_CUSTOM = 'CAR_MARKET_PRICE_CUSTOM'
export const CAR_MARKET_PRICE_FAIL = 'CAR_MARKET_PRICE_FAIL'
export const CAR_MARKET_PRICE_RESET = 'CAR_MARKET_PRICE_RESET'

export const priceFormat = (price) => price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")